export enum UserRole {
  ADMIN = 'admin',
  LINKER = 'linker',
  LEADER = 'leader',
  ANY = 'any',
}

export interface IUser {
  id: number
  role: UserRole
  code: string
  castId: string
  castName: string
  mail: string
  password: string
  isRewarded: boolean
  isValid: boolean
  createdAt: Date
  updatedAt: Date
  deletedAt: Date | null
}

export type InputEmailParam = {
  code: string
  mail: string
  url: string
}

export type PasswordSettingParam = {
  code: string
  password: string
  passwordResetToken: string
}

export type UsersParams = {
  id: number | null
  code: string | null
  castId: string | null
  castName: string | null
  role: UserRole | null
}

export enum UserType {
  ADMIN = 'admin',
  LINKER = 'linker',
  LEADER = 'leader',
}

export const userTypes = Object.values(UserType).map(value => {
  return {
    text:
      value === UserType.LINKER
        ? 'linker'
        : value === UserType.LEADER
        ? 'leader'
        : value === UserType.ADMIN
        ? 'admin'
        : null,
    value,
  }
})
